import rolesPermissionsCreate from './Create'
import rolesPermissionsEdit from './Edit'
import rolesPermissionsList from './List'

const rolesPermissionsResource = {
  list: rolesPermissionsList,
  create: rolesPermissionsCreate,
  edit: rolesPermissionsEdit,
}

export default rolesPermissionsResource
